import { render, staticRenderFns } from "./account_confirmaiton_page.vue?vue&type=template&id=4b2d20e8"
import script from "./account_confirmaiton_page.vue?vue&type=script&lang=js"
export * from "./account_confirmaiton_page.vue?vue&type=script&lang=js"
import style0 from "./account_confirmaiton_page.vue?vue&type=style&index=0&id=4b2d20e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports